var _ellipse, _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0,0 200,200",
    fill: "#F67535",
    stroke: "#F67535",
    strokeOpacity: 1,
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeMiterlimit: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-3,61,66)",
    cx: 61,
    cy: 66,
    rx: 17,
    ry: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 19,59 s 10,24 11,40 -23,48 -17,55 47,-3 57,-10 -3,-14 6,-30 41,-59 46,-70 -4,-9 -13,1 -28,46 -38,55 -17,5 -25,-4 -15,-43 -21,-53 -11,-9 -12,-5 6,21 6,21 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 155,130 l -151,34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 150,180 l 33,-19 10,-57 -28,-11 -15,87 -71,-11 48,-12 27,3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.51fe8b8d2bb1c0fb5211ca1995a5a498.svg";
export { ForwardRef as ReactComponent };